export default __webpack_public_path__ + "static/media/osk.e9de0187.svg";